"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddOrEditCollection = void 0;

var _react = _interopRequireWildcard(require("react"));

var _atoms = require("../../atoms");

var _molecules = require("../../molecules");

var _RoundButton = require("../../molecules/RoundButton");

var _index = require("../../index");

var _colors = _interopRequireDefault(require("./colors.json"));

require("./AddOrEditCollection.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AddOrEditCollection = function AddOrEditCollection(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      setName = _ref.setName,
      error = _ref.error,
      color = _ref.color,
      setPlaylistColor = _ref.setPlaylistColor,
      isPrivate = _ref.isPrivate,
      setPrivacy = _ref.setPrivacy;
  var initialColor = color ? color : 1;
  var initialPrivacy = !!isPrivate;

  var _useState = (0, _react.useState)(initialColor),
      _useState2 = _slicedToArray(_useState, 2),
      selectedColor = _useState2[0],
      setSelectedColor = _useState2[1];

  var _useState3 = (0, _react.useState)(initialPrivacy),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedPrivacy = _useState4[0],
      setSelectedPrivacy = _useState4[1];

  var setColor = function setColor(colorId) {
    if (setPlaylistColor) {
      setPlaylistColor(colorId);
    }

    setSelectedColor(colorId);
  };

  var togglePrivacy = function togglePrivacy() {
    if (setPrivacy) {
      setPrivacy(!selectedPrivacy);
    }

    setSelectedPrivacy(!selectedPrivacy);
  };

  return /*#__PURE__*/_react.default.createElement(_atoms.Column, null, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    center: true
  }, /*#__PURE__*/_react.default.createElement(_molecules.Input, {
    type: _molecules.Input.Type.Text,
    name: "playlist-name",
    value: name,
    placeholder: "Playlist name",
    onChange: function onChange(val) {
      return setName(val);
    },
    trkAction: "Name Field",
    error: error
  })), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "playlist-colors"
  }, _colors.default.map(function (color) {
    return /*#__PURE__*/_react.default.createElement(_RoundButton.RoundButton, {
      trkAction: "Color Selected",
      icon: selectedColor === color.id ? _atoms.Icon.Type.Check : null,
      color: _atoms.Color[color.value],
      backgroundColor: _atoms.Color[color.value],
      iconColor: _atoms.Color.Black,
      onClick: function onClick() {
        return setColor(color.id);
      },
      width: selectedColor === color.id ? 36 : 32,
      height: selectedColor === color.id ? 36 : 32,
      marginRight: "1",
      marginTop: "6",
      marginBottom: "6"
    });
  })), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    center: true
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "make-private-label"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, null, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    color: _atoms.Color.Black,
    content: "Make this playlist private"
  })), /*#__PURE__*/_react.default.createElement(_atoms.Row, null, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.SmallBody,
    color: _atoms.Color.Grey2,
    content: "Only you & your family can access"
  }))), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "make-private-switch"
  }, /*#__PURE__*/_react.default.createElement(_index.TRCToggle, {
    trkAction: "Private Toggled",
    checked: selectedPrivacy,
    onToggle: function onToggle() {
      return togglePrivacy();
    }
  }))));
};

exports.AddOrEditCollection = AddOrEditCollection;